'use client';

import { c as _c } from "react/compiler-runtime";
import { useSearchParams } from 'next/navigation';
import { useIsClient } from 'usehooks-ts';
import { SEARCH_PARAM_KEYS as AUTH_SEARCH_PARAM_KEYS } from '@/constants/auth';
import { useShareComponentBaseConfig } from '@/hooks/useShareComponentBaseConfig';
import { useShareComponentProfile } from '@/hooks/useShareComponentProfile';
import { Notification } from '@viveportengineering/share-component';
export default function AppTopNavNotification() {
  const $ = _c(9);
  const isClient = useIsClient();
  const searchParams = useSearchParams();
  const profile = useShareComponentProfile();
  let t0;
  if ($[0] !== searchParams) {
    t0 = searchParams.has(AUTH_SEARCH_PARAM_KEYS.PREVIEW);
    $[0] = searchParams;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const previewMode = t0;
  let t1;
  if ($[2] !== previewMode || $[3] !== profile) {
    t1 = {
      previewMode,
      profile
    };
    $[2] = previewMode;
    $[3] = profile;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  const {
    authConfig,
    localeConfig,
    originConfig
  } = useShareComponentBaseConfig(t1);
  if (!isClient) {
    return null;
  }
  let t2;
  if ($[5] !== authConfig || $[6] !== localeConfig || $[7] !== originConfig) {
    t2 = <Notification authConfig={authConfig} localeConfig={localeConfig} origin={originConfig} />;
    $[5] = authConfig;
    $[6] = localeConfig;
    $[7] = originConfig;
    $[8] = t2;
  } else {
    t2 = $[8];
  }
  return t2;
}